import ConstructionCone from "../images/ConstructionConeIcon.mjs";

/**
 * App icon indicating CVE
 * @desc NOTE: the CVE themselves, not search operations
 * @see {AppCpeCveExplorerIcon}
 * @see {GlyphIcon}
 * @see {ConstructionCone}
 */
const AppCpeCveIcon = class extends ConstructionCone {}

export default AppCpeCveIcon;